import BaseMenuList from '@material-ui/core/MenuList'

const MenuList = BaseMenuList

export default MenuList
